const state = {
  cardNo: '',
  data: ''
}

const mutations = {
  SET_DATA(state, { cardNo, data }) {
    state.cardNo = cardNo
    state.data = data
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
